module.exports = __webpack_public_path__ + "static/media/SWM.88f1da48.jpg";